import type { IconProps } from './types/types';

const TrustpilotIcon = (props: IconProps) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17924_2281)">
      <path
        d="M24.5694 9.13509H15.4064L12.576 0.410645L9.73699 9.13509L0.573975 9.12639L7.99468 14.5237L5.15533 23.2394L12.576 17.8508L19.9878 23.2394L17.1574 14.5237L24.5694 9.13509Z"
        fill="#00B67A"
      />
      <path
        d="M17.7944 16.497L17.1575 14.5237L12.5762 17.8508L17.7944 16.497Z"
        fill="#005128"
      />
    </g>
    <defs>
      <clipPath id="clip0_17924_2281">
        <rect
          width="24"
          height="22.8288"
          fill="white"
          transform="translate(0.571777 0.410645)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default TrustpilotIcon;
